import { FluentSerializer } from '@fluent/syntax';

const fluentSerializer: any = new FluentSerializer();

export default fluentSerializer;
